import React from 'react'
import { useActions, useValues } from 'kea'
import ReactHtmlParser from 'react-html-parser'
import PropTypes from 'prop-types'

import sceneLogic from '../logic'

const MenuElements = ({ isActive = false, onMouseEnter, onMouseLeave, customClassName, items }) => {
  const { setActiveSubMenu } = useActions(sceneLogic)
  const { activeSubMenu } = useValues(sceneLogic)

  const preventDefault = event => {
    event.preventDefault()
    event.stopPropagation()
  }

  const handleMouseEnter = event => {
    preventDefault(event)
    onMouseEnter && onMouseEnter()
  }

  const handleMouseLeave = event => {
    preventDefault(event)
    onMouseLeave && onMouseLeave()
  }

  const handleMenuElementClick = (menuItem, activeSubMenu, event) => {
    if (menuItem.children) {
      preventDefault(event)
      setActiveSubMenu(menuItem.name === activeSubMenu ? null : menuItem.name)
    }
  }

  return (
    <div
      className={`${customClassName} menu-${isActive === null ? 'default' : isActive ? 'open' : 'close'}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <ul>
        {items.map((menuItem, index) => {
          // in this case we can't add preventDefault to open subMenu items instead of redirect
          // Ctrl + Click doesn’t work for the "Delete Account" link because Rails UJS hijacks the link click event and prevents the browser’s default new-tab behavior.
          const methodProps = !menuItem.children
            ? { 'data-method': menuItem.method === 'delete' ? 'DELETE' : 'GET' }
            : {}
          return (
            <li key={`menu_item_${index}`} data-attr='links'>
              <a
                className={`element-content${menuItem.isAdmin ? ' admin-menu-element' : ''}${
                  menuItem.type === 'alert' ? ' alert' : ''
                }`}
                onClick={event => handleMenuElementClick(menuItem, activeSubMenu, event)}
                href={menuItem.link}
                {...methodProps}
              >
                <span>{ReactHtmlParser(menuItem.title)}</span>
                {menuItem.children && (
                  <span className={`with-children${menuItem.name === activeSubMenu ? ' with-children-open' : ''}`} />
                )}
              </a>
              {menuItem.children &&
                menuItem.children.map((childElement, subIndex) => (
                  <a
                    key={`menu_sub_item_${subIndex}`}
                    href={childElement.link}
                    className={`child-element-content${menuItem.isAdmin ? ' admin-menu-element ' : ''}${
                      menuItem.name === activeSubMenu ? ' open' : ' close'
                    }`}
                  >
                    <span>{ReactHtmlParser(childElement.title)}</span>
                  </a>
                ))}
            </li>
          )
        })}
      </ul>
    </div>
  )
}

MenuElements.propTypes = {
  isActive: PropTypes.bool,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  customClassName: PropTypes.string,
  items: PropTypes.array
}

export default MenuElements
